'use strict'

document.addEventListener("DOMContentLoaded", function(event) {
    /********************************
     * Variables
     *******************************/
    const html = document.querySelector('html');
    const body = document.querySelector('body');

    /********************************
     * Fixed menu
     *******************************/
    const menuFixed = document.querySelector('.menu-fixed');

    if(window.innerWidth > 992){
        document.addEventListener('scroll', () =>{
            if(window.scrollY >= 120){
                menuFixed.classList.add('animated', 'fadeInDown');
            }else if(window.scrollY < 120 && menuFixed.classList.contains('fadeInDown')){
                menuFixed.classList.remove('animated', 'fadeInDown');
            }
        });
    }

    /********************************
     * Show or hide mobile menu
     *******************************/
    const showMobileMenu = document.querySelector('.show-mobile-menu');
    const hideMobileMenu = document.querySelector('.hide-mobile-menu');

    showMobileMenu.addEventListener('click', (event) => {
        body.classList.add('show-menu');

        event.stopPropagation();
        let listener = function ({target}) {
            if(!target.closest('.menu-fixed')){
                body.classList.remove('show-menu');
                body.removeEventListener('click', listener);
            }
        };

        body.addEventListener('click', listener);
    });

    hideMobileMenu.addEventListener('click', ()=> body.classList.remove('show-menu'));

    /********************************
     * Show or hide countries popup
     *******************************/
    const popupSelect = document.querySelectorAll('.country-select');

    popupSelect.forEach(button =>{
        button.addEventListener('click', (event)=>{
            event.preventDefault();
            body.classList.remove('show-menu');
            body.classList.add('show-countries-modal');


            event.stopPropagation();
            let listener = function ({target}) {
                if(!target.closest('.country-items')){
                    body.classList.remove('show-countries-modal');
                    body.removeEventListener('click', listener);
                }
            };

            body.addEventListener('click', listener);
        });
    });

    /********************************
     * Show or hide form popup
     *******************************/
    const buttonResetLogin = document.querySelector('.trigger-form-reset');
    const buttonsLoginPopup = document.querySelectorAll('.trigger-login-popup');
    const buttonHidePopup = document.querySelector('.btn-close-modal');

    buttonResetLogin.addEventListener('click',  (event)=>{
        body.classList.add('show-popup', 'reset-popup');
        event.stopPropagation();
        /********* HIDE Popup *********/
        let listener = function ({target}) {
            if(!target.closest('.modal-content')){
                body.classList.remove('show-popup', 'reset-popup');
                body.removeEventListener('click', listener);
            }
        };
        body.addEventListener('click', listener);
    });

    buttonsLoginPopup.forEach(item =>{
        item.addEventListener('click', (event) =>{
            body.classList.add('show-popup', 'login-popup');
            event.stopPropagation();
            /********* HIDE Popup *********/
            let listener = function ({target}) {
                if(!target.closest('.modal-content')){
                    body.classList.remove('show-popup', 'login-popup');
                    body.removeEventListener('click', listener);
                }
            };
            body.addEventListener('click', listener);
        });
    });

    buttonHidePopup.addEventListener('click', ()=>{
        body.classList.remove('show-popup');

        body.classList.contains('login-popup')
            ? body.classList.remove('login-popup')
            : body.classList.remove('reset-popup')

        body.classList.contains('reset-popup')
            ? body.classList.remove('reset-popup')
            : body.classList.remove('login-popup')
    });


});

/********************************
 * Helpers
 *******************************/
const SkySmile = {};

SkySmile.delegateEvent = (parent, selector, type, fn) => {
    function delegatedFunction (event) {
        let target = event.target
        while (target && target !== parent) {
            if (target.matches(selector)) {
                event.delegatedTarget = target
                return fn.call(target, event)
            }
            target = target.parentNode
        }
    }
    parent.addEventListener(type, delegatedFunction)
    return delegatedFunction
}

SkySmile.getTemplate = (elm) => {
    let template = elm.dataset.templateCache;
    if (!template) {
        template = elm.querySelector('.sk-template').innerHTML;
        elm.dataset.templateCache = template;
    }

    return template;
}

SkySmile.templateReplace = (str, data) => {
    const keys = Object.keys(data);

    data = data || {};

    keys.forEach((key) => {
        const value = data[key];

        str = str.replace(new RegExp('\{'+ key +'\}', 'g'), value);
    });

    return str;
}

SkySmile.getBleachingProductProperties = () => {
    return [
        { objKey: 'doctorId', name: '__doctor_id' },
        { objKey: 'doctorName', name: '__doctor_name' }
    ];
}
